export enum ProductsViewState {
	LIST, GRID
}

export enum UpdatingProductsState {
	DOWNLOADING, PARSING, SAVING_CATEGORIES, SAVING_PRODUCTS, ERROR, PRE_COMPLETE, COMPLETE
}
